var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "backbone", "i18n/i18n"], function (require, exports, backbone_1, i18n_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ImageUploadView = void 0;
    backbone_1 = __importDefault(backbone_1);
    i18n_1 = __importDefault(i18n_1);
    class ImageUploadView extends backbone_1.default.View {
        constructor() {
            super(...arguments);
            this.tagName = "div";
        }
        template() {
            const dataURI = this.model.get("dataURI");
            return dataURI ? `
      <div class="image-preview-wrapper">
          <img src="${dataURI}" class="image-upload-preview" alt="${(0, i18n_1.default)("modal_upload_preview_placeholder")}" />
      </div>
    ` : `
      <div class="image-upload-wrapper">
        <img class="image-upload-icon" src="../img/upload.svg" alt="${(0, i18n_1.default)("modal_upload_icon_placeholder")}" />
        <p>
          <label for="image-upload" class="upload-hint">
            <input type="file" class="file-input" id="image-upload" accept="image/*" />
              ${(0, i18n_1.default)("modal_clickable_upload_hint")}
          </label> 
          <span>
            ${(0, i18n_1.default)("modal_rest_upload_hint")}
          </span>
        </p>
      </div>
    `;
        }
        initialize(options) {
            this.events = {
                "change .file-input": "onFileChange"
            };
            this.model = options.model;
            this.options = options;
            this.listenTo(this.model, "change", this.handleModelChange.bind(this));
            this.selectedFile = null;
        }
        render() {
            this.$el.html(this.template());
            this.delegateEvents();
            return this;
        }
        getTitle() {
            const title = this.model.get("dataURI") ? (0, i18n_1.default)("modal_image_preview") : (0, i18n_1.default)("modal_image_upload");
            return title;
        }
        //TODO: validate the Image , size,extension, etc.
        isValid() { }
        onFileChange(e) {
            return __awaiter(this, void 0, void 0, function* () {
                this.selectedFile = e.target.files[0] || null;
                if (!this.selectedFile)
                    return;
                try {
                    const dataUri = yield this.uploadFinished(this.selectedFile);
                    // console.log("Image uploaded:", dataUri);
                }
                catch (err) {
                    console.error("Failed to upload image:", err);
                }
            });
        }
        handleModelChange() {
            this.close();
        }
        close() {
            if (this.options.application.shadowRoot) {
                const overlay = this.options.application.shadowRoot.querySelector('.modal-backdrop');
                if (overlay) {
                    overlay.remove();
                }
            }
            if (typeof this.options.closeModal === "function") {
                this.options.closeModal();
            }
            this.destroy();
        }
        uploadFinished(blob) {
            return new Promise((resolve, reject) => {
                if (!blob) {
                    return reject(new Error("No blob provided"));
                }
                const reader = new FileReader();
                reader.onload = () => {
                    const dataURI = reader.result;
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        const maxWidth = 100;
                        const scale = maxWidth / img.width;
                        canvas.width = maxWidth;
                        canvas.height = img.height * scale;
                        const ctx = canvas.getContext("2d");
                        if (!ctx) {
                            return reject(new Error("Could not get canvas context"));
                        }
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        const thumbnailURI = canvas.toDataURL("image/jpeg", 0.8);
                        this.model.set({ "dataURI": dataURI, "thumbnailDataURI": thumbnailURI, "enabled": true });
                        resolve({ dataURI, thumbnailURI });
                    };
                    img.onerror = () => reject(new Error("Failed to load image"));
                    img.src = dataURI;
                };
                reader.onerror = () => reject(new Error("Failed to read file"));
                reader.readAsDataURL(blob);
            });
        }
        destroy() {
            this.selectedFile = null;
        }
    }
    exports.ImageUploadView = ImageUploadView;
});
